/* ============================================================
   AŞKIM: interactions
   Line reveals, parallax, grain, veil, header, menu, hero video,
   music, lightbox, accordions.

   Carried over from the static site's main.js. What that file drew from
   data.js (shop grid, product page, journal, cards) is now drawn by Liquid,
   so only the behaviour is here. Product, bag and filter behaviour live in
   product.js, cart.js and shop.js.
   ============================================================ */
window.ASKIMui = (function () {

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Page veil (gentle load reveal) ---------- */
  function veil() {
    if (RM) return;
    var v = document.createElement('div');
    v.className = 'page-veil';
    document.body.appendChild(v);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { v.classList.add('lifted'); });
    });
    setTimeout(function () { if (v.parentNode) v.parentNode.removeChild(v); }, 1200);
  }

  /* ---------- Film grain overlay ---------- */
  function grain() {
    if (RM || document.querySelector('.grain')) return;
    var g = document.createElement('div'); g.className = 'grain'; document.body.appendChild(g);
  }

  /* ---------- Heading line-reveal ---------- */
  function splitTitle(el) {
    if (el.dataset.split) return;
    el.classList.remove('reveal', 'd1', 'd2', 'd3', 'd4');
    var lines = el.innerHTML.split(/<br\s*\/?>/i);
    el.innerHTML = lines.map(function (l) {
      return '<span class="line"><span class="line__in">' + l + '</span></span>';
    }).join('');
    el.classList.add('reveal-title');
    el.dataset.split = '1';
  }
  function titles() {
    document.querySelectorAll('.hero h1, .page-hero h1, .section h2, .split h2, .section-head h2, .bg-burgundy h2, .concierge h2')
      .forEach(splitTitle);
  }

  /* ---------- Scroll reveal (handles .reveal and .reveal-title) ---------- */
  function reveal() {
    var els = document.querySelectorAll('.reveal:not(.in), .reveal-title:not(.in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }

    /* Cards that sit in a row arrive one after another rather than together.
       The delay is written as a custom property so the easing and duration
       stay in the stylesheet where the rest of the motion lives. */
    function stagger(el) {
      var grid = el.closest('.collection-grid, .product-grid, .journal-grid, .crafted__items');
      if (!grid) return 0;
      var i = [].indexOf.call(grid.children, el);
      return i > 0 ? Math.min(i, 6) * 70 : 0;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var d = stagger(en.target);
        if (d) en.target.style.setProperty('--reveal-delay', d + 'ms');
        en.target.classList.add('in');
        io.unobserve(en.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Editorial photographs drift a little slower than the page as it moves.
     Small numbers on purpose: enough to feel alive, not enough to notice as
     an effect. Off entirely under reduced motion. */
  function editorialDrift() {
    if (RM) return;
    var figs = [].slice.call(document.querySelectorAll('.split__media .figure'));
    if (!figs.length) return;
    var ticking = false;
    function upd() {
      var vh = window.innerHeight;
      figs.forEach(function (f) {
        var r = f.getBoundingClientRect();
        if (r.bottom < -80 || r.top > vh + 80) return;
        var mid = (r.top + r.height / 2) - vh / 2;
        var img = f.querySelector('img');
        if (img) img.style.transform = 'translate3d(0,' + (-mid * 0.045).toFixed(1) + 'px,0) scale(1.06)';
      });
      ticking = false;
    }
    function onScroll() { if (!ticking) { requestAnimationFrame(upd); ticking = true; } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    upd();
  }

  /* Leaving a page fades out instead of cutting to white. Only for links
     that stay on this site, and never for a new tab, a download, a modified
     click, or a link another script has already handled (the bag icon). */
  function pageExit() {
    if (RM) return;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      if (a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-no-exit')) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || /^(mailto:|tel:|https?:)/.test(href)) return;
      e.preventDefault();
      document.body.classList.add('leaving');
      setTimeout(function () { location.href = a.href; }, 260);
    });
    /* Coming back through the browser's back button restores the page from
       memory with the fade still applied. Clear it. */
    window.addEventListener('pageshow', function () { document.body.classList.remove('leaving'); });
  }

  /* ---------- Button-in-button trailing arrow ---------- */
  function magnetic() {
    document.querySelectorAll('.btn-arrow').forEach(function (b) {
      if (!b.querySelector('.btn__ico')) {
        var s = document.createElement('span'); s.className = 'btn__ico'; s.setAttribute('aria-hidden', 'true'); s.innerHTML = '&#8599;'; b.appendChild(s);
      }
    });
  }

  /* ---------- Subtle parallax (decorative only) ---------- */
  function parallax() {
    if (RM) return;
    var els = [].slice.call(document.querySelectorAll('[data-parallax]'));
    if (!els.length) return;
    var ticking = false;
    function upd() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -50 || r.top > vh + 50) return;
        var speed = parseFloat(el.dataset.parallax) || 0.12;
        var mid = (r.top + r.height / 2) - vh / 2;
        el.style.transform = 'translate3d(0,' + (-mid * speed).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    function onScroll() { if (!ticking) { requestAnimationFrame(upd); ticking = true; } }
    window.addEventListener('scroll', onScroll, { passive: true }); upd();
  }

  /* ---------- Header height on scroll ---------- */
  function header() {
    var h = document.getElementById('siteHeader');
    if (!h) return;
    var hero = document.querySelector('.hero, .page-hero');
    /* Stays burgundy with cream type at all times, per Meryem. What changes
       is the height: full at the top, compressed once you start reading.
       The two states are separated by a gap so a page resting near the
       boundary cannot flicker between them. */
    var compact = false;
    function upd() {
      var threshold = hero ? Math.min(hero.offsetHeight - 90, window.innerHeight - 90) : 40;
      h.classList.toggle('solid', window.scrollY > threshold);
      var y = window.scrollY;
      if (!compact && y > 90) { compact = true; h.classList.add('compact'); }
      else if (compact && y < 40) { compact = false; h.classList.remove('compact'); }
    }
    upd(); window.addEventListener('scroll', upd, { passive: true });
    if (!document.querySelector('.hero')) h.classList.add('solid');
  }

  /* ---------- Mobile menu ---------- */
  function menu() {
    var t = document.getElementById('menuToggle');
    var nav = document.getElementById('mobileNav');
    if (!t || !nav) return;
    function setOpen(o) {
      document.body.classList.toggle('menu-open', o);
      t.setAttribute('aria-expanded', o ? 'true' : 'false');
      if (o) { nav.removeAttribute('inert'); var f = nav.querySelector('a'); if (f) f.focus(); }
      else { nav.setAttribute('inert', ''); t.focus(); }
    }
    nav.setAttribute('inert', '');
    t.addEventListener('click', function () { setOpen(!document.body.classList.contains('menu-open')); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('menu-open')) setOpen(false);
    });
    nav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setOpen(false); }); });
  }

  /* ---------- Hero video ----------
     The film fades in over its own first frame as soon as it plays. It is
     only taken away if it truly fails to load, never for being slow: the
     old 1.6 second cut-off left phones on a still photograph instead of
     the film. */
  function heroVideo() {
    var v = document.querySelector('.hero__media video');
    if (!v) return;
    function show() { v.classList.add('ready'); v.style.opacity = '1'; }
    function hide() { v.style.display = 'none'; }
    v.addEventListener('playing', show);
    v.addEventListener('loadeddata', function () { if (v.readyState >= 2) show(); });
    v.addEventListener('error', hide, true);
    if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  }

  /* ---------- Optional music ---------- */
  function sound() {
    var btn = document.getElementById('soundToggle');
    var audio = document.getElementById('bgm');
    if (!btn || !audio) return;
    var on = false;
    btn.addEventListener('click', function () {
      on = !on;
      if (on) { audio.volume = 0.35; audio.play().catch(function () {}); btn.classList.add('playing'); btn.setAttribute('aria-label', 'Mute music'); }
      else { audio.pause(); btn.classList.remove('playing'); btn.setAttribute('aria-label', 'Play music'); }
    });
  }

  /* ---------- Lightbox ----------
     Reads the product gallery each time it opens, so a gallery redrawn after
     a colour change is still what the lightbox shows. */
  var box = null, lbImg = null, lbIdx = 0, lbSrcs = [], lbLast = null, lbFocus = [];
  function lbBuild() {
    if (box) return;
    box = document.createElement('div'); box.className = 'lightbox'; box.id = 'lightbox';
    box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Enlarged image gallery');
    box.innerHTML = '<button class="lightbox__close" type="button" aria-label="Close">&times;</button>' +
      '<button class="lightbox__nav prev" type="button" aria-label="Previous image">&#8249;</button>' +
      /* A transparent placeholder until an image is chosen. An <img> with no
         src at all is invalid and shows a broken-image mark in some browsers. */
      '<figure><img alt="" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"></figure>' +
      '<button class="lightbox__nav next" type="button" aria-label="Next image">&#8250;</button>';
    document.body.appendChild(box);
    lbImg = box.querySelector('img');
    lbFocus = [box.querySelector('.lightbox__close'), box.querySelector('.prev'), box.querySelector('.next')];
    lbFocus[0].addEventListener('click', lbClose);
    box.querySelector('.prev').addEventListener('click', function (e) { e.stopPropagation(); lbGo(-1); });
    box.querySelector('.next').addEventListener('click', function (e) { e.stopPropagation(); lbGo(1); });
    box.addEventListener('click', function (e) { if (e.target === box) lbClose(); });
    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('open')) return;
      if (e.key === 'Escape') { lbClose(); }
      else if (e.key === 'ArrowLeft') { lbGo(-1); }
      else if (e.key === 'ArrowRight') { lbGo(1); }
      else if (e.key === 'Tab') {
        var i = lbFocus.indexOf(document.activeElement);
        if (e.shiftKey && i <= 0) { e.preventDefault(); lbFocus[lbFocus.length - 1].focus(); }
        else if (!e.shiftKey && i === lbFocus.length - 1) { e.preventDefault(); lbFocus[0].focus(); }
      }
    });
  }
  function lbRender() { lbImg.src = lbSrcs[lbIdx]; lbImg.alt = 'Enlarged view ' + (lbIdx + 1); }
  function lbClose() { box.classList.remove('open'); if (lbLast && lbLast.focus) lbLast.focus(); }
  function lbGo(d) { lbIdx = (lbIdx + d + lbSrcs.length) % lbSrcs.length; lbRender(); }
  function lightbox() {
    var gallery = document.querySelector('.pdp__gallery');
    if (!gallery || gallery.dataset.lbBound) return;
    gallery.dataset.lbBound = '1';
    function figures() { return [].slice.call(gallery.querySelectorAll('.figure[data-full]:not([hidden])')); }
    function open(fig) {
      var figs = figures();
      lbSrcs = figs.map(function (f) { return f.getAttribute('data-full'); });
      if (!lbSrcs.length) return;
      lbBuild();
      lbLast = document.activeElement; lbIdx = Math.max(0, figs.indexOf(fig));
      lbRender(); box.classList.add('open'); lbFocus[0].focus();
    }
    gallery.addEventListener('click', function (e) {
      var f = e.target.closest('.figure[data-full]'); if (f) open(f);
    });
    gallery.addEventListener('keydown', function (e) {
      var f = e.target.closest('.figure[data-full]');
      if (f && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); open(f); }
    });
  }

  /* ---------- Accordion (product details, FAQ) ---------- */
  var accN = 0;
  function accordion(root) {
    (root || document).querySelectorAll('.acc__item').forEach(function (item) {
      var head = item.querySelector('.acc__head'), panel = item.querySelector('.acc__panel');
      if (!head || !panel || head.dataset.bound) return; head.dataset.bound = '1';
      if (!head.getAttribute('aria-controls')) {
        var pid = panel.id || ('accp' + (++accN));
        panel.id = pid; head.setAttribute('aria-controls', pid);
        head.setAttribute('aria-expanded', 'false'); panel.setAttribute('role', 'region');
      }
      var plus = head.querySelector('.plus'); if (plus) plus.setAttribute('aria-hidden', 'true');
      panel.setAttribute('inert', '');
      head.addEventListener('click', function () {
        var open = item.classList.toggle('open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { panel.removeAttribute('inert'); panel.style.height = panel.firstElementChild.offsetHeight + 'px'; }
        else { panel.setAttribute('inert', ''); panel.style.height = '0px'; }
      });
    });
  }

  /* ---------- Hide decorative inline SVGs from screen readers ---------- */
  function hideDecorativeSVG() {
    document.querySelectorAll('svg:not([aria-hidden])').forEach(function (s) {
      if (!s.getAttribute('role') && !s.querySelector('title')) s.setAttribute('aria-hidden', 'true');
    });
  }

  function init() {
    document.documentElement.classList.add('ui-ready');
    veil(); grain(); titles(); hideDecorativeSVG();
    header(); menu(); heroVideo(); sound(); magnetic(); parallax(); editorialDrift(); pageExit();
    lightbox(); accordion();
    reveal();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  return { reveal: reveal, accordion: accordion, lightbox: lightbox, magnetic: magnetic };
})();
